var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 199,
    viewBox: "0 0 199 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 98.5,
    fill: "#0038FF",
    stroke: "#0038FF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 77.5,
    r: 37.5,
    fill: "white",
    fillOpacity: 0.81
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154 160C154 171.025 142.362 177.848 129.892 181.994C110.595 188.41 89.4046 188.41 70.1084 181.994C57.638 177.848 46 171.025 46 160C46 136.252 76.2518 122 100 122C123.748 122 154 136.252 154 160Z",
    fill: "white",
    fillOpacity: 0.81
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.6d3972249e0500a78c0ad78026d1d300.svg";
export { ForwardRef as ReactComponent };